import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "col-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold mb-3" }, "EL SORTEO ESTÁ FINALIZADO", -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h5 class=\"text-uppercase fw-bold mb-3\"> Estos fueron los ganadores que gracias a Citroën Club pudieron disfrutar del show de JPEGMafia: </h5><ul><li>Facundo Cartolano</li><li>Claudio Angel Tuni</li><li>Marcela Alejandra Cordero</li><li>Leonardo Gabriel Crespo</li><li>Carlos Hernan Tocco</li><li>Rodolfo Frade</li><li>Sebastián Joel Lerner</li><li>Alfrego Augusto Stahlschmidt</li><li>Alberto Gustavo Spinetta</li><li>Norberto Rubén Scandroli</li></ul><h5 class=\"text-uppercase fw-bold mb-3\"> ¡Quedate atento que el próximo podés ser vos! </h5>", 3)
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = {
  key: 1,
  class: "col-12"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1)

import { cuponesService } from '@/services/cupones.service'
import { userService } from '@/services/user.service'
import { onMounted, ref } from 'vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'
import TheBasesYCondiciones from './bases-condiciones/TheBasesYCondiciones.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheSorteo',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string
};

const { getters } = useStore<VuexStore>(key)



const loading = ref(false)

const cuponesDisponibles = ref(false)
const cupon = ref()
const url = ref()

const couponRetrieved = ref(false)

const showByC = ref(false)

const termsContainer = ref<HTMLElement | null>(null)
const hasReadTerms = ref(false)

const handleScroll = (event: Event) => {
  const element = event.target as HTMLElement
  const reachedBottom =
    element.scrollHeight - element.scrollTop <= element.clientHeight + 1
  if (reachedBottom) hasReadTerms.value = true
}

const miCupon = async () => {
  const { codigo, store_url } = await userService.misCuponPorActividad(props.id)
  cupon.value = codigo
  url.value = store_url
}

const hayCuponesDisponibles = async () => {
  cuponesDisponibles.value = await cuponesService.hayCuponesDisponibles(
    props.id
  )
}
const obtenerCupon = async () => {
  loading.value = true
  const { codigo, store_url } = await cuponesService.obtenerCupon(props.id)
  cupon.value = codigo
  url.value = store_url
  loading.value = false
  couponRetrieved.value = true
}

onMounted(async () => {
  loading.value = true
  if (getters.isLogin) {
    await miCupon()
    if (!cupon.value) {
      await hayCuponesDisponibles()
    }
  }
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!cupon.value && !cuponesDisponibles.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            (_unref(getters).activity.id === 114)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    (!cupon.value && cuponesDisponibles.value && !couponRetrieved.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!showByC.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-sm bg-light text-dark",
                  type: "submit",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showByC.value = !showByC.value))
                }, " QUIERO PARTICIPAR ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                ([120, 123].includes(_unref(getters).activity.id))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      style: {"margin-top":"20px"},
                      class: "btn btn-sm bg-light text-dark",
                      type: "submit",
                      onClick: obtenerCupon
                    }, " PARTICIPAR "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        ref_key: "termsContainer",
                        ref: termsContainer,
                        onScroll: handleScroll,
                        style: {"height":"400px","width":"100%","overflow-y":"auto","padding":"20px","border":"1px solid #ccc"}
                      }, [
                        _createVNode(TheBasesYCondiciones, {
                          id: _unref(getters).activity.id
                        }, null, 8, ["id"])
                      ], 544),
                      _createElementVNode("button", {
                        style: {"margin-top":"20px"},
                        class: "btn btn-sm bg-light text-dark",
                        type: "submit",
                        onClick: obtenerCupon,
                        disabled: !hasReadTerms.value
                      }, " ACEPTO LOS TÉRMINOS Y CONDICIONES ", 8, _hoisted_12)
                    ], 64))
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (cupon.value || couponRetrieved.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          ([123].includes(_unref(getters).activity.id))
            ? (_openBlock(), _createElementBlock("b", _hoisted_14, "YA ESTÁS PARTICIPANDO POR EL SORTEO POR UN LUGAR EN LA EXPERIENCIA"))
            : (_openBlock(), _createElementBlock("b", _hoisted_15, "YA ESTAS PARTICIPANDO!")),
          _hoisted_16,
          ([120, 123].includes(_unref(getters).activity.id))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17))
            : (_openBlock(), _createBlock(TheBasesYCondiciones, {
                key: 3,
                id: _unref(getters).activity.id
              }, null, 8, ["id"]))
        ]))
      : _createCommentVNode("", true),
    _hoisted_18
  ]))
}
}

})